export const environment = {
  env: 'dev',
  apiUrl: 'https://devportal.thelift.mx/',
  backendUrl: 'http://devportal.thelift.mx/',
  preBidUrl: 'https://devportal.thelift.mx:8443/',
  production: true
};

export const cineburo_environment = {
  env: 'dev',
  apiUrl: 'https://devportal.cineburo.com/',
  backendUrl: 'http://devportal.cineburo.com/',
  preBidUrl: 'https://devportal.cineburo.com:8443/',
  production: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts